<template>
  <TreeRoot
    v-slot="{ flattenItems }"
    class="h-full list-none select-none bg-secondary flex flex-col text-sm font-medium"
    :items="filteredItems"
    :get-key="(item) => item.id"
    :expanded="expandedItems"
    multiple
    propagate-select
  >
    <div
      v-for="item in flattenItems"
      :key="item.value.id + item.index"
      v-bind="item.bind"
      @select.prevent
      :style="{ 'padding-left': `${item.level - 1}rem` }"
      class="bg-quaternary outline-none select-none relative"
    >
      <GroupBuilderItem
        @show:detail="$emit('show:detail', $event)"
        :item="item"
        :canExpand="
          (!isEditMode || isEditMode !== item.value.id) &&
          (!isDeleteMode || isDeleteMode !== item.value.id) &&
          item.value.children &&
          item.value.children.length > 0
        "
        :query="query"
        @update:open="handleToggle(item.value, item)"
        v-bind="item.bind"
        :class="{
          'bg-primary_hover': isAddMode === item.value.id,
        }"
      >
        <slot name="default" :data="{ item }"></slot>
      </GroupBuilderItem>
    </div>
  </TreeRoot>
</template>

<script setup>
import {
  watch,
  ref,
  onMounted,
  computed,
  watchEffect,
  defineExpose,
} from "vue";
import { TreeRoot } from "radix-vue";
import { clone } from "lodash";
import { GroupBuilderItem } from "@/SharedComponents/GroupBuilder";
import { useGroupBuilder } from "@/Composables/useGroupBuilder";

// Props
const props = defineProps({
  data: { type: Array, required: true },
  isEditMode: { type: undefined, default: false },
  isDeleteMode: { type: undefined, default: false },
  isAddMode: { type: undefined, default: false },
  query: { type: String, default: "" },
  type: { type: String, required: true },
});

// Emits
const emit = defineEmits(["move:item", "update:count"]);
// Refs
const items = ref(clone(props.data));

const { toggleNode, filteredItems, expandedItems, initialise, search } =
  useGroupBuilder(items.value, emit, props.type);

onMounted(() => {
  initialise();
});

const query = computed(() => props.query);

watch(query, () => {
  // Update search results when query changes
  search(items.value, props.query);
});

watchEffect(() => {
  // Emit updated count of filtered items
  emit("update:count", filteredItems.value.length);
});

const handleToggle = (value) => {
  toggleNode(value);
};

defineExpose({ handleToggle });
</script>
